var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-section'),_c('who-we-are'),_c('careers-hero'),_c('working-at-prospira'),_c('environment-hero'),_c('environment-policy'),_c('safety-hero'),_c('safety-policy'),_c('quality-hero'),_c('quality-policy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }